<div *ngIf="!resenyUkon.cancelled">
  <a [uiParams]="{id: resenyUkon.id}" [uiSref]="'doss.akce.data.ukony.detail'">{{ resenyUkon.typUkonu.description }}</a>
  ({{ StavUkonuUtils.getStavAndFazeUkonuDesc(resenyUkon.stavUkonu) }} {{ resenyUkon.stavUkonu.datumZmeny | date }})
</div>
